(() => {
  if (window.zptProductFaqsInitialized) return;
  window.zptProductFaqsInitialized = true;

  const initialized = new WeakSet();

  const initialize = (root = document) => {
    const sections = root.matches?.('[data-zpt-product-faqs]')
      ? [root]
      : [...root.querySelectorAll('[data-zpt-product-faqs]')];

    sections.forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);

      const items = [...section.querySelectorAll('.zpt-product-faqs__item')];

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
